import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { generateResizedImageUrl } from "../../../utils/httpService";

const Top5FeaturedNews = ({ items, talukaName }) => {
  const { assetbaseUrl } = useSelector(
    (state) => state?.SettingReducer?.data || {}
  );

  if (!items || items.length === 0) return null;

  const getImage = (item, width, height) => {
    const itemMedia = item.media || item.image_path || item.image;
    if (!itemMedia) return null;
    const path = itemMedia.startsWith("http") ? itemMedia : `${itemMedia.startsWith('/') ? itemMedia.slice(1) : itemMedia}`;
    return generateResizedImageUrl(width, height, path);
  };

  const mainItem = items[0];
  const sideItems = items.slice(1, 4);

  return (
    <div className="row featured-top5-row mb-4">
      {/* Left Large Card */}
      <div className="col-lg-7 col-md-12 mb-3 mb-lg-0">
        <Link to={`/${mainItem.url}`} className="featured-main-card">
          <img src={getImage(mainItem, 563, 480)} alt={mainItem.title} />
          <div className="featured-main-overlay">
            <span className="featured-main-tag" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
              {parseInt(mainItem.is_live) === 1 && (
                <span className="live-now-badge" style={{ margin: 0 }}>
                  <span className="live-now-dot"></span>
                  LIVE
                </span>
              )}
              <span>{mainItem.tagline || mainItem.category || `${talukaName} સમાચાર`}</span>
            </span>
            <h2 className="featured-main-title">{mainItem.title || mainItem.gujarati_title || mainItem.name}</h2>
          </div>
        </Link>
      </div>

      {/* Right Side 5 Small Cards */}
      {sideItems.length > 0 && (
        <div className="col-lg-5 col-md-12 pl-lg-4">
          <div className="featured-side-list">
            {sideItems.map((item, idx) => (
              <Link key={idx} to={`/${item.url}`} className="featured-side-card">
                <div className="side-card-img-wrap">
                  <img src={getImage(item, 166, 93)} alt={item.title} />
                </div>
                <div className="side-card-content">
                  <span className="side-card-tag" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '6px' }}>
                    {parseInt(item.is_live) === 1 && (
                      <span className="live-now-badge" style={{ margin: 0 }}>
                        <span className="live-now-dot"></span>
                        LIVE
                      </span>
                    )}
                    <span>{item.tagline || item.category || `${talukaName} સમાચાર`}</span>
                  </span>
                  <h4 className="side-card-title">{item.title || item.gujarati_title || item.name}</h4>
                  <span className="side-card-readmore">
                    વધુ વાંચો <i className="fa fa-angle-right"></i>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Top5FeaturedNews;
